<template>
  <section class="dbData" :id="dbName+'Data'" role="tabpanel" :aria-labelledby="dbName+'Tab'" :aria-expanded="[isFirst ? 'true' : 'false']">
    <template v-for="(record, index) in records">
      <div :key="'head'+index" class="dbData_h">
        <h2 v-if="record.title" tabindex="-1">{{ record.title }}</h2>
      </div>
      <!--情報エリア-->
      <div :key="'body'+index" class="infoArea">
        <!--画像ギャラリー-->
        <galleryCarousel v-if="images" :images="images" @parentFunc="openZoomModal"></galleryCarousel>
        <!--/画像ギャラリー-->
        <!--詳細情報-->
        <div v-if="record.fields" class="detail">
          <table class="detail_data">
            <tr v-for="(value, name, index) in record.fields" :key="index">
              <th>{{ name }}</th>
              <td v-html="join(value)"></td>
            </tr>
          </table>
        </div>
        <!--/詳細情報-->
      </div>
      <!--/情報エリア-->
    </template>
  </section>
</template>

<script>
import i18n from '@/i18n.js'
import galleryCarousel from '@/components/galleryCarousel.vue'

export default {
  components: {
    galleryCarousel
  },
  props: {
    dbName: { type: String, required: true },
    records: { type: Array, required: true },
    images: { type: Array, required: true },
    isFirst: { type: Boolean, required: true },
  },
  data () {
    return {
      swiperOption: {
        slidesPerView: 4,
        spaceBetween: 12,
        navigation: {
          nextEl: '.gallery_carousel_next',
          prevEl: '.gallery_carousel_prev'
        }
      }
    }
  },
  filters: {
    // 英語ページの場合は英語ページへのリンクにする
    lang (path) {
      return i18n.locale == 'en' ? '/en'+path : path
    }
  },
  methods: {
    // 配列になっている値の結合
    join (val) {
      if (Array.isArray(val)) {
        return val.length ? val.join(', ') : "-"
      } else {
        return val ? val : "-"
      }
    },
    openZoomModal(target) {
      this.$emit('parentFunc', target)
    },
  }
}
</script>
